"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vePREONStake = void 0;
const Decimal_1 = require("./Decimal");
/**
 * Represents the change between two states of a vePREON Stake.
 *
 * @public
 */
class vePREONStake {
    /** @internal */
    constructor(preonStake = Decimal_1.Decimal.ZERO, vePREONGain = Decimal_1.Decimal.ZERO, vePREONTotal = Decimal_1.Decimal.ZERO, totalUserPreon = Decimal_1.Decimal.ZERO, totalPreon = Decimal_1.Decimal.ZERO, preonEarned = Decimal_1.Decimal.ZERO, rewardRate = Decimal_1.Decimal.ZERO, accumulationRate = Decimal_1.Decimal.ZERO, boostAmount = Decimal_1.Decimal.ZERO, boostFactor = Decimal_1.Decimal.ZERO, boostRewardRate = Decimal_1.Decimal.ZERO, boostBasePartition = Decimal_1.Decimal.ZERO, preonStakeOnFarm = Decimal_1.Decimal.ZERO, boostSumOfFactors = Decimal_1.Decimal.ZERO, vePreonOnFarm = Decimal_1.Decimal.ZERO) {
        this.preonStake = preonStake;
        this.vePREONGain = vePREONGain;
        this.vePREONTotal = vePREONTotal;
        this.totalUserPreon = totalUserPreon;
        this.totalPreon = totalPreon;
        this.preonEarned = preonEarned;
        this.rewardRate = rewardRate;
        this.accumulationRate = accumulationRate;
        this.boostAmount = boostAmount;
        this.boostFactor = boostFactor;
        this.boostRewardRate = boostRewardRate;
        this.boostBasePartition = boostBasePartition;
        this.preonStakeOnFarm = preonStakeOnFarm;
        this.boostSumOfFactors = boostSumOfFactors;
        (this.vePreonOnFarm = vePreonOnFarm);
    }
    get isEmpty() {
        return this.preonStake.isZero && this.vePREONGain.isZero && this.vePREONTotal.isZero;
    }
    /**
     * Compare to another instance of `PREONStake`.
     */
    equals(that) {
        return (this.preonStake.eq(that.preonStake) &&
            this.vePREONGain.eq(that.vePREONGain) &&
            this.vePREONTotal.eq(that.vePREONTotal));
    }
}
exports.vePREONStake = vePREONStake;
//# sourceMappingURL=vePREONStake.js.map